<era-blinds-ui [blindPosition]="currentBlindPosition$ | async"
               [curtainPosition]="currentCurtainPosition$ | async"></era-blinds-ui>